module.exports = __webpack_public_path__ + "img/icon-close-orange.780c5065.svg";